import {
  GetAmendmentsRecordResponseDto,
  UpdateAmendmentsRecordBody,
  UpdateAmendmentsRecordResponseDto
} from '@/models/Amendments.model';
import { createAmendmentValidationSchema } from '@/routes/ops/amendments/components/CreateNewAmendmentDialog.component';

import * as yup from 'yup';

import ApiService from './Api.service';

export type CreateAmendmentsRecordDto = yup.InferType<
  typeof createAmendmentValidationSchema
>;

export class AmendmentsService {
  static async createAmendment(
    planId: number,
    data: CreateAmendmentsRecordDto
  ): Promise<{ id: number; createdAt: string; updatedAt: string }> {
    return await ApiService.postJson(`/amendments/${planId}`, data);
  }

  static async updateAmendmentById(
    amendmentId: number,
    data: UpdateAmendmentsRecordBody
  ): Promise<UpdateAmendmentsRecordResponseDto> {
    return await ApiService.patchJson(`/amendments/${amendmentId}`, data);
  }

  static async getAmendments(
    status?: string,
    search?: string,
    searchType?: string,
    productTierIds?: number[],
    billableAmounts?: string[],
    assignee?: string,
    adminStatus?: string,
    firmId?: number
  ): Promise<GetAmendmentsRecordResponseDto[]> {
    return await ApiService.getJson('/amendments', {
      adminStatus,
      assignee,
      billableAmounts,
      firmId,
      productTierIds,
      search,
      searchType,
      status
    });
  }
}
